import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Field, FieldGroup } from '@/components/ui/field';
import { getAuth, GoogleAuthProvider, signInWithRedirect } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const provider = new GoogleAuthProvider();
// provider.setCustomParameters({
//     hd: 'yourcompany.com', // restrict to internal domain
// });

const handleGoogleSignIn = async () => {
	const auth = getAuth();
	try {
		await signInWithRedirect(auth, provider);
	} catch (error) {
		// Handle error (show snackbar, etc.)
		console.error(error);
	}
};

function Login() {
	const { user } = useAuth();
	const navigate = useNavigate();

	if (user) {
		navigate('/', { replace: true });
	}

	return (
		<div className="flex flex-col gap-6">
			<Card>
				<CardHeader>
					<CardTitle>Login to your account</CardTitle>
					<CardDescription>
						Enter your email below to login to your account
					</CardDescription>
				</CardHeader>
				<CardContent>
					<form>
						<FieldGroup>
							<Field>
								<Button
									variant="outline"
									type="button"
									onClick={handleGoogleSignIn}
								>
									Login with Google
								</Button>
							</Field>
						</FieldGroup>
					</form>
				</CardContent>
			</Card>
		</div>
	);
}

export { Login };
